import React from "react";
import {
  Box,
  Typography,
  Autocomplete,
  TextField,
  Paper,
  Grid,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { Abc, ShoppingBag, ShoppingCart } from "@mui/icons-material";
import Person3Icon from "@mui/icons-material/Person3";
import FolderIcon from "@mui/icons-material/Folder";

export default function SingleTicketCard({ ticket }) {
  console.log(ticket, "ticket");

  return (
    <Box>
      <Grid>
        {/* <Box
          sx={{
            margin: 2,
            width: "100%",
            backgroundColor: "white",
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              padding: 2,
            }}
          >
            {ticket.CallUrl && (
              <audio
                style={{
                  width: "100%",
                  borderRadius: "8px",
                }}
                src={ticket.CallUrl}
                controls
              />
            )}
          </Box>
        </Box> */}
        <Box
          sx={{
            bgcolor: "white",

            overflowX: "auto",
            mt: 1,
          }}
        >
          <Typography sx={{ p: 1 }}>Ticket Details</Typography>
          <TableContainer>
            <Table
              sx={{
                minWidth: 650,
                bgcolor: "white", // Background color for the table
                borderCollapse: "collapse", // Ensure borders collapse
              }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    Name :
                  </TableCell>
                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    Email :
                  </TableCell>
                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    Company Name :
                  </TableCell>
                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    Title :
                  </TableCell>

                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    Description :
                  </TableCell>
                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    Status :
                  </TableCell>
                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    CreateDate
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    {ticket.name}{" "}
                  </TableCell>
                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    {ticket.email}{" "}
                  </TableCell>
                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    {ticket.businessName}
                  </TableCell>
                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    {ticket.title}
                  </TableCell>
                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    {ticket.issue}
                  </TableCell>
                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    {ticket.status}
                  </TableCell>
                  <TableCell
                    sx={{ border: "8px solid white", bgcolor: "#F4F5FA" }}
                  >
                    {ticket.createdAt}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>
    </Box>
  );
}
